<template>
    <div id="purchaseOrderChangeManage">
        <el-row class="clearfix" style="margin-bottom: 15px;">
            <el-col class="fl" :span="2">
                <el-button v-if="basicsAuth.purchasingChangeAdd" size="medium" type="success" @click="createOrder()">新建采购变更单</el-button>
            </el-col>
            <el-col class="fr" :span="1">
                <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
             </el-col>
        </el-row>
        <el-col class="fl searthPart" style="width: 20.5%;">
            <el-form ref="searchForm" :model="searchForm" label-width="0px" :label-position="labelPosition">
                <el-form-item>
                    <el-date-picker
                        style="width: 100%;"
                        v-model="valueTime1"
                        type="daterange"
                        range-separator="-"
                        :default-time="['00:00:00', '11:59:59']"
                        start-placeholder="开始"
                        end-placeholder="结束">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <template>
                        <el-radio-group v-model="searchForm.status">
                            <el-radio :label="item.value" v-for="(item,index) in statusList" :key="index">{{item.name}}</el-radio>
                        </el-radio-group>
                    </template>
                </el-form-item>
                <el-form-item>
                    <el-input style="margin-bottom: 15px;" clearable v-model.trim="searchForm.code" placeholder="请输入采购变更编号" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select filterable style="margin-bottom: 15px;width:100%" clearable v-model="searchForm.createUser" placeholder="请选择创建人">
                        <el-option v-for="(item,index) in pickingUserAllList" 
                            :label="item.staffName" 
                            :value="item.staffName" 
                            :key="index">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-button type="success" @click="onSubmit('searchForm')" style="width:100%;margin-top: 20px;">检索采购订单</el-button>
            </el-form>
        </el-col>
        <el-col class="fr" style="width: 77.5%;">
            <el-card class="box-card fr" style="width: 100%;">
                <el-table
                    :data="supplierData"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%"
                    @row-click="goToDetail">
                    <el-table-column
                        align="center"
                        prop="code"
                        width="150"
                        label="变更编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="150"
                        prop="pId"
                        label="采购订单编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="status"
                        label="状态">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createUser"
                        label="创建人">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="createTime"
                        :formatter="dateFormat"
                        label="变更时间">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="memo"
                        label="备注内容">
                    </el-table-column>
                </el-table>
            </el-card>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import { purchasingChangeList,queryUser} from "../../api/api";
    import {getPermission} from '../../api/authRequest';

    export default {
        name: 'purchaseOrderChangeManage',
        components: {},
        data () {
            return {
                orderId:'',
                valueTime1:[],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                pickingUserAllList:[],
                supplierForm:{
                    supplier_name: '',
                    supplier_contacts: '',
                    supplier_phone:'',
                    supplier_address:'',
                    time_out: '',
                    supplier_status: true,
                },
                searchForm:{
                    attribute1:'',
                    attribute2:'',
                    createUser: '',
                    code: '',
                    status: '',
                },
                statusList:[
                    {
                        name:'已确认',
                        value:'已确认'
                    },

                ],
                supplierData: [
                    {
                        code: '',
                        pId: '',
                        status:'',
                        createUser:'',
                        createTime: '',
                        memo:'',
                    },
                ],
                basicsAuth:{
                    purchasingChangeAdd:false
                }
            }
        },
        created(){
            this.$destroy(); //销毁生命周期
            this.basicsAuth.purchasingChangeAdd = getPermission('/api/purchase/purchasingChangeAdd');
        },
        mounted () {
            this.getPurchasingChangeList();
            this.queryUserAllList();  
        },
        methods: {
            //查询所有系统账号
            queryUserAllList(){
                queryUser({type:2}).then(res =>{
                    if(res.data.status == '100'){
                        this.pickingUserAllList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取采购变更单列表
            getPurchasingChangeList(){
                let para={
                    code: this.searchForm.code,
                    createUser: this.searchForm.createUser,
                    status: this.searchForm.status,
                    attribute1: this.searchForm.attribute1,
                    attribute2: this.searchForm.attribute2,
                    startRow: this.pages.page,
                    pageSize: this.pages.pageSize
                }
                purchasingChangeList(para).then(res => {
                    if (res.data.status==100) {
                        this.supplierData = res.data.results.list
                        this.pages.total = res.data.results.total
                        // console.log(res.data.results)
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getPurchasingChangeList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getPurchasingChangeList()
            },
            //时间转化函数
            dateFormat:function(row, column) {
                var date = row[column.property];
                if (date == undefined) {
                    return "";
                }
                return moment(date).format("YYYY-MM-DD");
            },
            //进入详情页面
            goToDetail(row) {
                // console.log(row.status)
                this.orderId = row.id
                if (row.status !=='草稿') {
                    this.$router.push({
                        path:'/purchaseOrderChangeInfo',
                        query:{
                            orderId:this.orderId
                        }
                    })
                }else{
                    this.$router.push({
                        path:'/newChangePurchaseOrderChangeOrder',
                        query:{
                          orderId:this.orderId
                        }
                    })
                }
            },
            //新建采购变更单
            createOrder() {
                this.$router.push({
                    path:'/newPurchaseOrderChangeOrder',
                })
            },
            refresh() {
                this.searchForm = {}
                this.getPurchasingChangeList()
            },
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        if(this.valueTime1 == null){
                            this.searchForm.attribute1 = ''
                            this.searchForm.attribute2 = ''
                        }else if (this.valueTime1.length == 0) {
                            this.searchForm.attribute1 = ''
                            this.searchForm.attribute2 = ''
                        }else{
                            this.searchForm.attribute1 = this.moment(this.valueTime1[0]).format("YYYY-MM-DD");
                            this.searchForm.attribute2 = this.moment(this.valueTime1[1]).format("YYYY-MM-DD");
                        }
                        this.getPurchasingChangeList()
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    #purchaseOrderChangeManage{
        font-size: 14px;
        .headerT{
            font-size: 16px;
            margin:0 0 15px 0;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        .toolbar{
            margin: 20px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// purchaseOrderChangeManage.vue?1a5b6ec6